import { render } from "./List.vue?vue&type=template&id=6b8cfd0d&scoped=true&ts=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=6b8cfd0d&scoped=true&lang=css"

import exportComponent from "/Users/georgemayer/Sites/apps/lognote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8cfd0d"]])

export default __exports__